export const GET_PACKAGE_SOURCE_LIST = 'GET_PACKAGE_SOURCE_LIST';
export const SET_PACKAGE_SOURCE_LIST = 'SET_PACKAGE_SOURCE_LIST';
export const CLEAR_PACKAGE_SOURCE_LIST = 'CLEAR_PACKAGE_SOURCE_LIST';
